let baseUrl = "https://mangiami2.fly.dev";
if (window && window.location.hostname.indexOf("localhost") > -1) {
  baseUrl = "http://localhost:3001";
}

export const BASE_URL = baseUrl;
export const API_URL = `${baseUrl}/api`;
